import React, { useEffect, useState } from 'react';
import { saveJournalEntry, getJournalEntries } from '../firebaseUtils';

function ProgressJournal({ goalId, goalTitle }) {
  const [entries, setEntries] = useState([]);
  const [newEntry, setNewEntry] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (goalId) fetchEntries();
  }, [goalId]);

  const fetchEntries = async () => {
    setLoading(true);
    const data = await getJournalEntries(goalId);
    setEntries(data);
    setLoading(false);
  };

  const handleAddEntry = async () => {
    if (newEntry.trim() === '') return;
    setSaving(true);
    await saveJournalEntry(goalId, newEntry);
    setNewEntry('');
    await fetchEntries();
    setSaving(false);
  };

  return (
    <div>
      <h2 style={{
        fontFamily: 'Bangers, sans-serif',
        fontSize: '1.8rem',
        letterSpacing: '2px',
        color: '#fff',
        marginBottom: '6px',
      }}>
        📘 Progress Journal
      </h2>
      <p style={{ fontStyle: 'italic', color: '#aaa', marginBottom: '20px' }}>
        Logging progress for: <strong style={{ color: '#fff' }}>{goalTitle || 'Selected Goal'}</strong>
      </p>

      <textarea
        rows="3"
        placeholder="Write your progress update..."
        value={newEntry}
        onChange={(e) => setNewEntry(e.target.value)}
        style={{
          width: '100%',
          padding: '12px',
          margin: '10px 0',
          borderRadius: '8px',
          border: '1px solid #444',
          backgroundColor: '#222',
          color: '#fff',
          fontSize: '1rem',
          resize: 'vertical',
          boxSizing: 'border-box',
        }}
      />

      <button
        onClick={handleAddEntry}
        disabled={saving}
        style={{
          backgroundColor: saving ? '#555' : '#FFD700',
          color: '#000',
          border: 'none',
          borderRadius: '8px',
          padding: '12px 24px',
          fontSize: '1rem',
          fontFamily: 'Bangers, sans-serif',
          letterSpacing: '1px',
          cursor: saving ? 'not-allowed' : 'pointer',
          marginBottom: '24px',
        }}
      >
        {saving ? 'Saving...' : '➕ Add Entry'}
      </button>

      {loading ? (
        <p style={{ color: '#888' }}>Loading entries...</p>
      ) : entries.length === 0 ? (
        <p style={{ color: '#888', fontStyle: 'italic' }}>No entries yet. Start logging your progress!</p>
      ) : (
        <ul style={{ listStyleType: 'none', paddingLeft: 0, marginTop: '10px' }}>
          {entries.map((entry) => (
            <li
              key={entry.id}
              style={{
                background: '#222',
                padding: '14px',
                marginBottom: '10px',
                borderLeft: '4px solid #FFD700',
                borderRadius: '6px',
              }}
            >
              <strong style={{ color: '#FFD700' }}>
                {entry.createdAt?.toDate().toLocaleDateString(undefined, {
                  year: 'numeric', month: 'long', day: 'numeric'
                })}
              </strong>
              <p style={{ margin: '6px 0 0 0', color: '#ddd' }}>{entry.text}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default ProgressJournal;